<template>
<div class="admeditor">
    <div class="adjust_block" v-if="cur_type == 'adjust_user'">
            <b-row>
                <b-col sm="3">
                    <div>
                        <b-button :disabled="is_locked_button" block variant="success"
                                  @click="agree_action('adjust')">
                            Погоджую
                        </b-button>

                        <b-button :disabled="is_locked_button" block variant="danger"
                                  @click="dis_agree_action('adjust')">
                            Не погоджую
                        </b-button>
                    </div>
                </b-col>

                <b-col sm="9">
                    <vue-editor  :editor-toolbar="editor_rules"  id="result2" v-model="form.text"></vue-editor>
            </b-col>
            </b-row>
        </div>
    <div class="recipient_block" v-if="cur_type == 'recipient_user'">
        <b-row>
            <b-col sm="3">
                <div>
                    <b-button :disabled="is_locked_button" block variant="success"
                              @click="agree_action('recipient')">
                        Погоджую
                    </b-button>

                    <b-button :disabled="is_locked_button" block variant="danger"
                              @click="dis_agree_action('recipient')">
                        Не погоджую
                    </b-button>
                </div>
            </b-col>

            <b-col sm="9">
                <vue-editor  :editor-toolbar="editor_rules"  id="results" v-model="form.text"></vue-editor>
            </b-col>
        </b-row>
    </div>

    <div class="isp_block_accept" v-if="cur_type === 'isp_user_accept'">

        <b-row class="mem_create_row" >
            <b-col sm="3">
                <date-picker value-type="format" v-model="form.date_to" :lang="d_lang" confirm :first-day-of-week="1"></date-picker>

                <div class="add user" @click="delegate">
                    <i title="" class="fa add_user fa-plus-square" data-type="delegate_users"></i>
                    <span>Делегування</span>
                </div>

                <div class="users_delegate">
                    <div class="user_list u_list" v-if="form.users.length > 0">
                        <div class="isp_list" >
                            <user_block
                                    v-for="(item) in form.users"
                                    :key="item.id"
                                    v-bind:user="item">
                            </user_block>
                        </div>
                    </div>
                </div>


            </b-col>

            <b-col sm="9">
                <vue-editor  :editor-toolbar="editor_rules"  id="result_isp_acc" v-model="form.text"></vue-editor>
            </b-col>
        </b-row>
        <b-row class="mem_create_row" >
            <b-col sm="3">
                <b-button :disabled="is_locked_button" block variant="success"
                          @click="agree_action('isp_accept')">Прийняв в роботу</b-button>
            </b-col>
        </b-row>
    </div>

    <div class="isp_block_work" v-if="cur_type === 'isp_user_work'">
        <b-row>

            <b-col sm="12">
                <vue-editor  :editor-toolbar="editor_rules"  id="d_isp_acc" v-model="form.text"></vue-editor>
            </b-col>

            <b-col sm="3" class="pt-3 mt-3 pb-3 mb-3">
                <b-button :disabled="is_locked_button"  block variant="success"
                          @click="agree_action('isp_work_end')">Виконав</b-button>
            </b-col>
        </b-row>
    </div>

    <div class="delegate_block_accept" v-if="delegate_operation">
        <b-row>
            <b-col sm="3">
                <date-picker v-if="cur_type === 'delegate_user_accept'"
                             value-type="format"
                             v-model="form.date_to"
                             :lang="d_lang"
                             :first-day-of-week="1"
                             confirm>
                </date-picker>

                <b-button :disabled="is_locked_button" v-else block variant="success"
                          @click="agree_action('delegate_work_end')">Виконав</b-button>

            </b-col>

            <b-col sm="9">
                <vue-editor  :editor-toolbar="editor_rules"  id="delegate_isp_acc" v-model="form.text"></vue-editor>
            </b-col>
        </b-row>

        <b-row class="mem_create_row" v-if="cur_type === 'delegate_user_accept'">
            <b-col sm="3">
                <b-button :disabled="is_locked_button" block variant="success"
                          @click="agree_action('delegate_accept')">Прийняв в роботу</b-button>
            </b-col>
        </b-row>
    </div>




    <div class="init_close" v-if="cur_type === 'init_user_close'">
        <b-row>

            <b-col sm="12">
                <vue-editor  :editor-toolbar="editor_rules"  id="d_ini_acc" v-model="form.text"></vue-editor>
            </b-col>

            <b-col sm="3" class="pt-3 mt-3 pb-3 mb-3">
                <b-button :disabled="is_locked_button"  block variant="success"
                          @click="agree_action('init_close')">В Архів</b-button>
            </b-col>
        </b-row>


    </div>

</div>

</template>

<script>
    import { VueEditor } from "vue2-editor";
    import DatePicker from 'vue2-datepicker'
    import user_block from "../../../../../../../shared/user/user_block/user_block.vue";

    export default {
        name: "admineditor",
        props: {
            row : {
                type : Object,
                required: true
            }

        },
        components : {
            VueEditor,
            DatePicker,
            user_block
        },

        data() {
            return {
                form: {
                    text: '',
                    status: -1,
                    date_to: '',
                    mem_files: [],
                    users : [],
                    type: '',
                    doc_id: 0
                },
                is_locked_button : false,
                editor_rules: [
                    ["bold", "italic", "underline", "link"],
                    [{align: "center"}, {align: "right"}, {align: "justify"}],
                    [{list: "ordered"}, {list: "bullet"}, {list: "check"}],
                ],
            }
        },

        methods: {

            lock_buttons(flag) {
                this.is_locked_button = flag;
                return this;
            },


            agree_action(type) {

                this.form.doc_id = this.mem_id;
                if(type !== 'isp_accept') {
                    this.form.status = 1;
                }
                this.form.type = type;
                this.lock_buttons(true).send_action();
            },

            dis_agree_action(type) {
                this.form.doc_id = this.mem_id;
                this.form.status = 0;
                this.form.type = type;
                this.lock_buttons(true).send_action();
            },

            delegate_add (users) {
                this.form.users = users;
            },

            async send_action() {

                let send = this.form;
                send.user_id = this.user_id;
                
                let url = '/memorandums/'+ this.mem_id +'/admin/action/' + this.form.type;
                
                await api.patch(url, {
                    'form' : send
                }).then(({data}) => {
                    if (data.status === "operation_success") {
                        console.log(data);
                        this.lock_buttons(false);

                        EventBus.$emit('show_toast', {err: 'Збережено', type: "success", title: 'Обробка'})
                        EventBus.$emit('refresh_tabs', {
                            tabs: [
                                'tab_monitoring',
                                'tab_resolution',
                                'tab_work'
                            ]
                        });
                    }
                }).catch(err => {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                    this.lock_buttons(false);
                });

            },

            delegate() {
                EventBus.$emit('load_users_filter', {uniq: this.delegate_uniq});
            }
        },

        created ()  {
            EventBus.$on('selected_users', e => {
                if(e !== undefined && e.uniq === this.delegate_uniq) {
                    this.delegate_add(e.users);
                }
            });

            console.log(this.row);
        },

        computed : {

            is_isp_accept () {

            },

            delegate_operation () {
                return this.cur_type === 'delegate_user_work' || this.cur_type === 'delegate_user_accept';
            },

            delegate_uniq () {
                return 'delegate_adm_' + this.mem_id;
            },
            cur_type () {
               return this.row.cur_right;
            },

            mem_id () {
                return this.row.mem_id;
            },

            user_id () {
                return this.row.user_id;
            },
            d_lang () {
                return this.get_datepickLang();
            },
        }

    }
</script>

<style scoped>
    button[disabled] {
        opacity: 0.3;
    }
    button[disabled]:hover {
        opacity: 0.3;
    }

    .add.user {
        font-size: 26px;
        margin-top: 15px;
        cursor: pointer;
        text-align: center;
    }



</style>
